
export function TrainingNudgesSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img
                src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=500&fit=crop&crop=center"
                alt="Employee training nudges interface"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
            
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Turn Every Risk Into a Learning Moment
              </h2>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed">
                When risky behavior is detected, Driscop sends real-time educational nudges that help employees learn safe habits through micro-interactions rather than formal training sessions.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-lightbulb-line text-green-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Contextual Learning</h3>
                    <p className="text-gray-400">Training appears exactly when it's needed, making lessons more relevant and memorable.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-user-line text-green-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Personalized Approach</h3>
                    <p className="text-gray-400">Each employee receives training tailored to their specific risk patterns and behavior.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-trophy-line text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Measurable Improvement</h3>
                    <p className="text-gray-400">Track behavioral changes and see 85% improvement in security awareness across your team.</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 bg-green-50 rounded-xl">
                <div className="flex items-center mb-3">
                  <i className="ri-information-line text-green-600 mr-2"></i>
                  <span className="font-semibold text-green-800">Did You Know?</span>
                </div>
                <p className="text-green-700">
                  Traditional cybersecurity training has only 15% retention after 6 months. Our contextual nudges achieve 85% behavioral improvement because learning happens in real-time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
